import { render } from "./LearningHubHero.vue?vue&type=template&id=131ab2ca&scoped=true"
import script from "./LearningHubHero.vue?vue&type=script&lang=js"
export * from "./LearningHubHero.vue?vue&type=script&lang=js"

import "./LearningHubHero.vue?vue&type=style&index=0&id=131ab2ca&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-131ab2ca"]])

export default __exports__